import { render, staticRenderFns } from "./workAllocation.vue?vue&type=template&id=71bbe440&scoped=true"
import script from "./workAllocation.vue?vue&type=script&lang=js"
export * from "./workAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bbe440",
  null
  
)

export default component.exports